import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Grid,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Button,
  Divider,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";

function BusinessLinesPage() {
  const pageTitle = "Voice - Business Lines";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [currency, setCurrency] = useState(null);
  const [resultData, setResultData] = useState({});
  const [businessLines, setBusinessLines] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [centerTitle, setCenterTitle] = useState(null);
  const [canCall, setCanCall] = useState(true);
  const [canReceive, setCanReceive] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  async function deleteLine(ref) {
    if (window.confirm("Are you sure you want to delete?") === false) {
      return;
    }
    setShowLoading(true);
    await axios
      .get(`/portal/voice/business_lines/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const tableColumns = [
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        title: row.title,
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Call Logs">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  navigate(`/voice/business-lines/calls/${row.reference}`);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  list
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;&nbsp;
            <Tooltip title="Manage">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  navigate(`/voice/business-lines/${row.reference}`);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  settings
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                deleteLine(row.reference);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/voice/business_lines.json`)
        .then((result) => {
          // console.log(result.data.data.campaign.activation);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrency(result.data.currency);
            setResultData(result.data.data);

            const rows = buildRows(result.data.data.lines);
            setBusinessLines(rows);
            setPhoneNumbers(result.data.data.phone_numbers);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createBusinessLine() {
    if (centerTitle === null) {
      setSeverity("error");
      setErrMsg("Enter center name.");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Enter center name.");
      setOpen(true);
      return;
    }

    if (selectedNumber === null) {
      setSeverity("error");
      setErrMsg("Enter center name.");
      setOpen(true);
      return;
    }

    setOpenCreateDialog(false);
    setShowLoading(true);
    const json = {
      title: centerTitle,
      phone_number: selectedNumber,
      receiver_phone_number: phoneNumber,
    };

    await axios
      .post("portal/voice/business_lines/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          await statusDialog.show(result.data.data.message, "success", "Success!");
          // setRefreshPage(!refreshPage);
          navigate(`/voice/business-lines/${result.data.data.reference}`);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openCreateDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Business Line</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={1}>
              <MDInput
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setCenterTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Select Number</InputLabel>
                <Select
                  label="Select Number"
                  onChange={(e) => {
                    setSelectedNumber(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    phoneNumbers.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      phoneNumbers.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>

            <MDBox mt={3}>
              <MDInput
                name="title"
                margin="dense"
                label="Receiving Phone Number (Inbound Calls)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <MDTypography variant="caption" fontWeight="regular" px={1}>
                Note: Incoming calls from your customers will be sent to this number
              </MDTypography>
            </MDBox>
            <MDBox mt={3}>
              <Table>
                <TableRow>
                  <TableCell>
                    <MDTypography>
                      <MDTypography fontSize={12}>Price</MDTypography>
                    </MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontSize={12}>
                      {currency}
                      {(resultData.fee / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <MDTypography>
                      <MDTypography fontSize={12}>VAT</MDTypography>
                    </MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontSize={12}>
                      {currency}
                      {(resultData.vat / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <MDTypography>
                      <MDTypography fontSize={14} fontWeight="bold">
                        Total
                      </MDTypography>
                    </MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontWeight="bold" fontSize={14}>
                      {currency}
                      {((resultData.fee + resultData.vat) / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </TableCell>
                </TableRow>
              </Table>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createBusinessLine();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={1} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={1}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>phone</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                        Business Lines
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={16}>
                        Get a professional number for your business.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3} mb={3}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setCenterTitle(null);
                          setCanCall(true);
                          setCanReceive(false);
                          setOpenCreateDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Create Business Line
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Business Lines
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setCenterTitle(null);
                            setSelectedNumber(null);
                            setPhoneNumber(null);
                            setOpenCreateDialog(true);
                          }}
                        >
                          <Icon>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox p={0}>
                    <DataTable
                      table={{ columns: tableColumns, rows: businessLines }}
                      canSearch={false}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BusinessLinesPage;
